import { action, computed, makeObservable, observable } from 'mobx';

import { EntryTranslationStatus, Locale } from 'chaika-enums';
import { EntryTranslationData, EntryTranslationFieldData } from 'chaika-frontend-types/frontend-cms';

export class EntryTranslation {
    @observable public locale: Locale;
    @observable public status: EntryTranslationStatus;
    @observable public fieldList: Map<string, EntryTranslationFieldData>;

    constructor(params: EntryTranslationData) {
        makeObservable(this);
        this.locale = params.locale;
        this.status = params.status;
        this.fieldList = new Map(params.fields.map(field => [field.fieldName, field]));
    }

    @computed
    public get isConfirmed(): boolean {
        return this.status === EntryTranslationStatus.Confirmed;
    }

    @action
    public updateField(fieldParams: EntryTranslationFieldData): void {
        const field = this.fieldList.get(fieldParams.fieldName);
        if (field) {
            this.fieldList.set(fieldParams.fieldName, { ...field, ...fieldParams });
        } else {
            this.fieldList.set(fieldParams.fieldName, { ...fieldParams, isAutoTranslate: false });
        }
    }

    @action
    public updateStatus(status: EntryTranslationStatus): void {
        this.status = status;
    }
}
